export const GENC_DATOS_USUARIO_ERROR = 'GENC_DATOS_USUARIO_ERROR';
export const GENC_DATOS_USUARIO_LOAD = 'GENC_DATOS_USUARIO_LOAD';
export const GENC_DATOS_USUARIO_EXITOSO = 'GENC_DATOS_USUARIO_EXITOSO';
export const GENC_BLOQUEO_PASOS_GENERAL = 'GENC_BLOQUEO_PASOS_GENERAL';
export const GENC_INTENTO_DOCUMENTO = 'GENC_INTENTO_DOCUMENTO';
export const GENC_INTENTO_VOLVER_TOKEN = 'GENC_INTENTO_VOLVER_TOKEN';
export const GENC_INTENTO_CONFIRMAR_TOKEN = 'GENC_INTENTO_CONFIRMAR_TOKEN';
export const GENC_INTENTO_CAMBIO_CLAVE = 'GENC_INTENTO_CAMBIO_CLAVE';
export const GENC_TOKEN_MOD_GENCLAVEWEB = 'GENC_TOKEN_MOD_GENCLAVEWEB';
export const ERROR_GENERICO_CLAVE_WEB = 'ERROR_GENERICO_CLAVE_WEB';